import { Identifiable, Planzone, ProjectPortfolio } from "@planzone/dto";

function extractProjectPortfolios(
  planzone: Identifiable<Planzone>,
): Identifiable<ProjectPortfolio>[] {
  return planzone.data && !!planzone.data.projectPortfolios
    ? JSON.parse(planzone.data.projectPortfolios)
    : [];
}

function isProjectPortfolioDuplicate() {
  return (planzone: Identifiable<Planzone>, portfolio: ProjectPortfolio) =>
    Promise.resolve(
      !!extractProjectPortfolios(planzone).find(
        ({ name }) => name === portfolio.name,
      ),
    );
}

export { isProjectPortfolioDuplicate };
